import './Billing.css';

const UsageProgress = ({ label, used, total, unit = '' }) => {
    // Handle unlimited (-1)
    const isUnlimited = total === -1;
    const percent = isUnlimited ? 0 : Math.min((used / total) * 100, 100);

    let colorClass = '';
    if (!isUnlimited) {
        if (percent >= 90) colorClass = 'danger';
        else if (percent >= 75) colorClass = 'warning';
    }

    return (
        <div className="usage-item">
            <div className="usage-label">
                <span>{label}</span>
                <span className="usage-value">
                    {used} {unit} / {isUnlimited ? 'Unlimited' : `${total} ${unit}`}
                </span>
            </div>
            {!isUnlimited && (
                <div className="billing__progress-bar-container">
                    <div
                        className={`billing__progress-bar ${colorClass}`}
                        style={{ width: `${percent}%` }}
                    />
                </div>
            )}
            {isUnlimited && (
                <div className="billing__progress-bar-container">
                    <div
                        className="billing__progress-bar"
                        style={{ width: '100%', background: 'linear-gradient(90deg, var(--primary), var(--success))' }}
                    />
                </div>
            )}
        </div>
    );
};

export default UsageProgress;
